var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssociatedPressLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 103.133,
    height: 119.387,
    viewBox: "0 0 103.133 119.387",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Associated_Press_logo",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82117",
    "data-name": "Path 82117",
    d: "M0,107.16H103.133V.238H0Z",
    transform: "translate(0.001 -0.238)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82118",
    "data-name": "Path 82118",
    d: "M0,77.994H103.133V90.458H0V77.994",
    transform: "translate(0.001 28.929)",
    fill: "#ff322e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82119",
    "data-name": "Path 82119",
    d: "M21.992,20.7,4.656,72.7H17.208L28.983,35.944l5.9,18.376H27.25L24.2,64.809H38.254l2.534,7.89H53.7l-17.334-52H21.992m51.43,0H55.4v52H67.863V31.189h5.022c5.827,0,9.144,2.779,9.144,7.8,0,4.931-3.318,7.8-9.144,7.8h-.807v10.49h1.344c13.448,0,21.338-6.77,21.338-18.29,0-11.745-7.89-18.29-21.338-18.29",
    transform: "translate(1.747 7.438)",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssociatedPressLogo);
export default __webpack_public_path__ + "static/media/Associated_Press_logo.c8d5bb3dc4a5762b43749598b3563da8.svg";
export { ForwardRef as ReactComponent };